module.exports = __webpack_public_path__ + "toBride1-we-p-b.43fc343a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-p-b.jpg
// module id = Yxuh
// module chunks = 0